import React from 'react'
import { ComponentExt } from '../../../util/reactExt'
import { Pagination } from 'antd'
import Cate from '../../../components/layout/CateLayout'
import Card from '../../../components/Card'
import { RouteComponentProps } from '../../../../node_modules/@types/react-router'
import { isNil, get } from 'lodash'
import { Carousel } from 'antd'
import * as styles from './index.scss'

interface Props extends RouteComponentProps<any> {}

interface State {
  indexMap: number[]
  tagIndex: number
  categorys: any[]
  datalist: any
  id: number
  pageindex: number
  isLoading: boolean
  bannerList: any[]
}

class Collection extends ComponentExt<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      indexMap: [0, 0, 0, 0],
      id: -1,
      pageindex: 1,
      tagIndex: 0,
      categorys: [],
      datalist: { data: [], total: 0 },
      isLoading: true,
      bannerList: [],
    }
  }

  async componentDidMount() {
    this.fetchBanner()
    // 获取分类菜单
    await this.fetchMenu()

    // 刷新路由缓存：读取分类菜单状态缓存
    this.storageSelectedStates()

    // SPA缓存
    const storeTopicsDataList = localStorage.getItem(`topicsDataList`)
    if (!isNil(storeTopicsDataList)) {
      this.setState({
        datalist: JSON.parse(storeTopicsDataList),
        isLoading: false,
      })
    } else {
      await this.fetchList(this.state.id)
      localStorage.setItem(
        `topicsDataList`,
        JSON.stringify(this.state.datalist),
      )
    }
  }

  storageSelectedStates() {
    const query = new URLSearchParams(this.props.location.search)
    const id = Number(query.get('id'))
    const indexMap = JSON.parse(query.get('state'))

    if (Array.isArray(indexMap)) {
      this.setState({
        indexMap,
        id,
      })
    }
  }

  async fetchBanner() {
    const data = await this.api.banner.getHomeBannerList(5000106)
    this.setState({
      bannerList: data,
    })
  }

  async fetchMenu() {
    const storeData = localStorage.getItem(`topicsCategorys`)
    let categorys

    if (!isNil(storeData)) {
      categorys = JSON.parse(storeData)
    } else {
      const data = await this.api.topic.getCategory()
      categorys = this.formateMenuData(data[0].child)
      localStorage.setItem(`topicsCategorys`, JSON.stringify(categorys))
    }

    this.setState({
      categorys,
      id: this.computedId(categorys[0]),
    })
  }

  formateMenuData(data) {
    function formateNode(node, i, arr) {
      if (node.child && node.child.length) {
        node.child.forEach((child, index) => formateNode(child, index, node))
      } else {
        node.last = true
        // if (
        //   !arr.child[0].category_name.includes('全部') &&
        //   arr.child.every(a => a.child.length === 0)
        // ) {
        //   arr.child.unshift({
        //     category_name: '全部',
        //     child: [],
        //     last: true,
        //     id: arr.child
        //       .reduce((total, current) => {
        //         return total.concat([current.id])
        //       }, [])
        //       .toString(),
        //   })
        // }
      }
    }

    (Array.isArray(data) ? data : [data]).forEach(formateNode)

    return data
  }

  computedId(item) {
    function iterator(arr) {
      return arr.child.findIndex(c1 => c1.last === true) === 0
        ? arr.child[0].id
        : arr.child.find(c1 => c1.last === true) &&
          arr.child.every(c1 => c1.child.length === 0)
          ? arr.child.find(c1 => c1.last === true).id
          : iterator(arr.child[0])
    }

    return item.child.length ? iterator(item) : item.id
  }

  renderMenu = () => {
    const { categorys, indexMap } = this.state
    return (
      categorys.length > 0 && (
        <ul className={styles.menulist}>
          {indexMap.map((m, i) => {
            let currentData = categorys

            if (i === 0) {
              currentData = categorys
            } else if (i === 1) {
              currentData = categorys[indexMap[0]].child.length
                ? categorys[indexMap[0]].child
                : []
            } else if (i === 2) {
              currentData =
                categorys[indexMap[0]].child.length &&
                categorys[indexMap[0]].child[indexMap[1]].child.length
                  ? categorys[indexMap[0]].child[indexMap[1]].child
                  : []
            } else if (i === 3) {
              const categoryChild = categorys[indexMap[0]].child[indexMap[1]]
              currentData =
                get(categoryChild, 'child.length') &&
                get(categoryChild, 'child[indexMap[2]].child.length')
                  ? get(categoryChild, 'child[indexMap[2]].child')
                  : []
            }
            return currentData.length ? (
              <li key={`g${i}`}>
                {currentData.map((c0, c0Index) => (
                  <span
                    key={`li${c0Index}`}
                    className={m === c0Index ? styles.light : ''}
                    onClick={() =>
                      this.handleC1Click(i, c0Index, c0.id, c0, c0.last)
                    }
                  >
                    {c0.category_name}
                  </span>
                ))}
              </li>
            ) : null
          })}
        </ul>
      )
    )
  }

  handleC1Click(c, index, id, item, isLast?) {
    const indexMap = this.state.indexMap

    for (let i = 3; i > c; i--) {
      indexMap[i] = 0
    }

    const computedIds = this.computedId(item)

    indexMap[c] = index

    this.setState({
      indexMap,
      id: computedIds,
      pageindex: 1,
      tagIndex: 0,
    })

    const { history, location } = this.props

    history.replace({
      pathname: location.pathname,
      search: `?state=${JSON.stringify(indexMap)}&id=${computedIds}`,
    })

    this.fetchList(computedIds)
  }

  async fetchList(id, pageindex = 1, sort = 0) {
    try {
      const data = await this.api.topic.getList(
        id,
        { pageindex, pagesize: 8 },
        sort,
      )
      this.setState({
        datalist: data,
        isLoading: false,
      })
    } catch (err) {
      this.setState({
        isLoading: false,
      })
      console.error(err.message)
    }
  }

  toDetail(id, type, content) {
    if (type === '1000105') {
      return window.open(content, '_blank')
    }

    window.open(`#/topicdetail/${id}`, '_blank')
  }

  handleChange = (_, val) => {
    const { id } = this.state
    this.setState({
      tagIndex: val,
      datalist: { data: [], total: 0 },
      isLoading: true,
      pageindex: 1,
    })
    this.fetchList(id, 1, val)
  }

  handleCategory = id => {
    this.setState({
      id,
      datalist: { data: [], total: 0 },
      pageindex: 1,
    })
    this.fetchList(id)
  }

  pageChange = page => {
    const { id, tagIndex } = this.state
    this.setState({
      pageindex: page,
    })
    window.scrollTo(0, 444)
    this.fetchList(id, page, tagIndex)
  }

  render() {
    const { tagIndex, datalist, pageindex, isLoading, bannerList } = this.state
    return (
      <div className={styles.topic}>
        <Carousel>
          {bannerList.map(banner => (
            <div key={banner.img_url}>
              <img src={banner.img_url} alt={banner.remark} />
            </div>
          ))}
        </Carousel>
        <div className={styles.collectionHeader} style={{ marginBottom: 16 }}>
          {this.renderMenu()}
        </div>
        <Cate
          title=""
          type={4}
          leftTabs={['最新', '最热']}
          index={tagIndex}
          tabChange={this.handleChange}
          loading={isLoading}
          notitle
        >
          {datalist.total > 0 &&
            datalist.data.map(
              ({ id, img_url, title, view_count, type, content }, idx) => (
                <Card
                  key={`fccard-${idx}`}
                  type="middle"
                  dataType={type}
                  cover={img_url}
                  title={title}
                  watch={view_count}
                  onClick={() => this.toDetail(id, type, content)}
                />
              ),
            )}
        </Cate>
        <div style={{ textAlign: 'center' }}>
          <Pagination
            hideOnSinglePage={true}
            total={datalist.total}
            current={pageindex}
            pageSize={8}
            onChange={this.pageChange}
          />
        </div>
      </div>
    )
  }
}

export default Collection
